import OrderLimit from './index';

export default { path: '/home/orderLimit', component: OrderLimit };
